@if (messageThread) {
<div class="app-message-thread-details">
  <div class="app-message-thread-details-header">
    <div class="app-message-thread-details-header-description">
      <h5 class="app-message-thread-details-header-description-heading">{{ messageThread.subject }}</h5>
      <span class="app-message-thread-details-header-description-date">{{ messageThread.createdAt | appDate: locale.language }}</span>
    </div>
    <div class="app-message-thread-details-header-delete">
      <a nz-button nzType="link" (click)="removeMessageThread()" translate>messages.threadDetails.deleteThread</a>
    </div>
  </div>
  <nz-list class="app-message-thread-details-list" nzGrid>
    @for (message of messageThread.messages; track message.id) {
    <div nz-row #messages>
      <div nz-col nzSpan="24">
        <nz-list-item nz-row class="app-message-thread-details-list-item">
          <nz-list-item-meta nz-col class="app-message-thread-details-list-item-meta">
            <nz-list-item-meta-avatar><app-avatar [text]="message.avatarName" [size]="'32px'"></app-avatar></nz-list-item-meta-avatar>
            <nz-list-item-meta-title>{{ message.avatarName }}</nz-list-item-meta-title>
            <nz-list-item-meta-description>{{ message.createdAt | appDateTime: locale.language }}</nz-list-item-meta-description>
          </nz-list-item-meta>
          <div class="app-message-thread-details-list-item-body" [innerHTML]="message.body"></div>
          <nz-list-footer>
            <app-file-upload [files]="message.attachments" [readonly]="true"></app-file-upload>
          </nz-list-footer>
        </nz-list-item>
      </div>
    </div>
    }
  </nz-list>
  <form class="app-message-thread-details-form" nz-form nzLayout="vertical" [formGroup]="form" (ngSubmit)="sendMessage()">
    <app-send-message [form]="form" [rowHeight]="8"></app-send-message>
    <div class="app-new-message__form-footer">
      <div class="app-new-message__form-footer__attachment">
        <app-file-upload (uploading)="fileUploading($event)" (changed)="fileListUpdated($event)" [files]="messageAttachments"></app-file-upload>
      </div>
      <div class="app-new-message__form-footer__buttons">
        <button nz-button nzType="primary" type="submit" [disabled]="!form.valid || uploading" [nzLoading]="sendMessageButtonLoading$ | async" translate>
          messages.threadDetails.send
        </button>
      </div>
    </div>
  </form>
</div>
}
